module.exports = __webpack_public_path__ + "media/images/icon/icons8-Privacy-d815c244aa24767e25ebc6581c808454.png";